module.exports = __webpack_public_path__ + "static/media/vtex29.47705409.png";